module.exports = __webpack_public_path__ + "img/miri_img01.6901bb8b.png";